import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import LoyaltyLockIcon from '~/icons/components/LoyaltyLockIcon/LoyaltyLockIcon';
import PlatinumUnlockedMessage from '~/pdp/components/PlatinumUnlockedMessage/PlatinumUnlockedMessage';
import BaseMarketingCallout from '~/pdp/components/ProductDetailMarketingCallout';
import PreorderTag from '~/shared/components/PreorderTag';
import ProductRatingContainer from '~/shared/components/ProductRatingContainer/ProductRatingContainer';
import { isPreorderEligibleBySelectedProduct } from '~/shared/utils/isPreorderEligibleBySelectedProduct';
import {
  desktop,
  useProductDetailContext,
  useBreakpoint,
} from '~/techstyle-shared/react-components';

const DesktopHeaderWrapper = styled.div`
  ${({ theme }) => theme.pdpStyles.productNameMargin};
`;

const MobileHeaderWrapper = styled.div`
  grid-area: mobileHeaderArea;
  margin: 0;
  padding: 16px;
  width: 100%;
  display: block;
`;

const CalloutWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 8px;

  ${({ theme }) => theme.pdpStyles.mobileHeaderCallout}
`;

const TitleWrapper = styled.div`
  ${({ theme }) => theme.pdpStyles.mobileHeaderTitle}
`;

const ProductNameWrapper = styled.div`
  display: inline-block;
  margin-bottom: 8px;
  position: relative;
`;

const ProductDetailMarketingCallout = styled(BaseMarketingCallout)`
  ${desktop`
    margin-bottom: 8px;
  `}
`;

const StyledLoyaltyLockIcon = styled(LoyaltyLockIcon)`
  margin-left: -5px;
  margin-top: -2px;
  bottom: 0;
  top: auto;
`;

function PDPHeaderContent({
  isLocked,
  isPlatinumExclusive,
  product,
  productName,
  showProductRating,
  productRef,
  reviewSectionRef,
}) {
  const { isMobile } = useBreakpoint();
  const { selectionStateByProductIndex } = useProductDetailContext();
  const showPreorder = isPreorderEligibleBySelectedProduct(
    product,
    selectionStateByProductIndex
  );
  const showLockedIcon = isPlatinumExclusive && isLocked;

  return (
    <>
      {isMobile && (
        <MobileHeaderWrapper>
          {isPlatinumExclusive && !isLocked && <PlatinumUnlockedMessage />}
          <TitleWrapper>
            <ProductNameWrapper>
              {productName}
              {showLockedIcon && (
                <StyledLoyaltyLockIcon width={32} height={32} color="black" />
              )}
            </ProductNameWrapper>
            {showProductRating && (
              <ProductRatingContainer
                productRef={productRef}
                reviewSectionRef={reviewSectionRef}
              />
            )}
          </TitleWrapper>
          <CalloutWrapper>
            {showPreorder && (
              <PreorderTag dataAutotag="Pre-Order_Product_Title" />
            )}
            <ProductDetailMarketingCallout />
          </CalloutWrapper>
        </MobileHeaderWrapper>
      )}
      {!isMobile && (
        <DesktopHeaderWrapper>
          <ProductNameWrapper>
            {productName}
            {showLockedIcon && (
              <StyledLoyaltyLockIcon width={32} height={32} color="black" />
            )}
          </ProductNameWrapper>
          {showPreorder && (
            <PreorderTag dataAutotag="Pre-Order_Product_Title" />
          )}
          {showProductRating && (
            <ProductRatingContainer
              productRef={productRef}
              reviewSectionRef={reviewSectionRef}
            />
          )}
          <ProductDetailMarketingCallout />
        </DesktopHeaderWrapper>
      )}
    </>
  );
}

PDPHeaderContent.propTypes = {
  isLocked: PropTypes.bool,
  isPlatinumExclusive: PropTypes.bool,
  product: PropTypes.object,
  productName: PropTypes.element,
  productRef: PropTypes.object,
  reviewSectionRef: PropTypes.object,
  showProductRating: PropTypes.bool,
};

export default PDPHeaderContent;
